

// 维度类型
export const DIMENSION_TYPE = {
    CONTENT: 'content',//内容
    CONTENT_DIMENSION: 'CONTENT_DIMENSION',//内容 + 维度 使用CONDITION_CONTENT_DIMENSION_FORM 判断
    DATE: 'date_range',//日期
    DATE_SELECT: 'date_select',//日期 + 维度
}
//维度 弹框 选项
export const DIMENSION_TYPE_DATA = {
    yy_type: {
        bloc_yy_type: '按集团',
        company_yy_type: '按客户',
        account_yy_type: '按账户',
        project_yy_type: '按项目',
        subproject_yy_type: '按推广',
        plan_yy_type: '按计划',
    },
    create_date: {
        idea_create_date: '按创意',
    },
    start_date: {
        idea_name: '按创意',
        material_name: '按素材',
    }
}
// 格式化为下拉框选项
export const DIMENSION_TYPE_DATA_LIST = Object.keys(DIMENSION_TYPE_DATA).reduce((pre, key)=> {
    const data = DIMENSION_TYPE_DATA[key];
    pre[key] = Object.keys(data).map(name=> {
        return {
            name,
            display_name: data[name]
        }
    })
    return pre;
}, {});

// 维度 定制日期表单
export const DIMENSION_DATE_FORM = [ 'date' ];

// 维度 维度选择
export const DIMENSION_DATE_DIMENSION_FORM = [ 'create_date', 'start_date','yy_type' ];

// 筛选  有维度的筛选
export const CONDITION_CONTENT_DIMENSION_FORM = [ 'yy_type' ]

//没有筛选的维度
export const DIMENSION_NO_FILTER_LIST = [ 'm_material_url', 'm_material_size', 'wk_material_url', 'wk_material_size'];

// 日期类型
export const DATE_TYPE = {
    day: '天',
    week: '周',
    month: '月',
    quarter: '季度',
    year: '年',
};

// 默认的弹框数据 再添加的时候需要加上
export const DEFAULT_SELECT_MODAL_DATA = {
    conditionCheckList_yy_type: {
        dimension: 'account_yy_type',
    },
    conditionCheckList_create_date: {
        dimension: 'idea_create_date',
    },
    conditionCheckList_start_date: {
        dimension: 'material_name',
    },
    dimensionCheckList_date: {
        sum_type: 'day',
        order_by: 'date',
        order_type: 'desc'
    },
    dimensionCheckList_yy_type: {
        dimension: 'account_yy_type',
    },
    dimensionCheckList_create_date: {
        dimension: 'idea_create_date',
    },
    dimensionCheckList_start_date: {
        dimension: 'material_name',
    },
}
// 默认选中的数据
export const DEFAULT_SELECT_DATA = {
    conditionCheckList: [],
    dimensionCheckList: [ 'm_material_url', 'plat_id', 'date'],
    fieldsCheckList: [ 'cost' ]
};


/**
    数据日期：昨日
    维度默认：媒体素材内容、投放媒体、数据日期（天）
    指标默认：总消耗（如果用户没有权限则不显示）
 */

// 复制页面缓存的数据key
export const STOR_SELECT_DATA_KEY = 'STOR_SELECT_DATA_KEY';
// 冻结列的类型
export const FROZEN_COL_TYPE = Object.freeze({
    FIRST_COLUMN: "FIRST_COLUMN",
    ALL_DIMENSION: 'ALL_DIMENSION',
    CUSTOM: 'CUSTOM'
});
// 是否需要禁用固定所有维度的 数量
export const DIS_ALL_DIMENSION_NUM = 8;
// 需要排序的维度字段
export const SORT_DATA_LIST = [ "date", "create_date", "start_date"];
// 数字类型数据过滤
export const FILTER_NUMBER_DATA = {
    greater_than:   { text: '大于等于',     input: 1, value:'>=' },
    greater:        { text: '大于',        input: 1, value:'>'} ,
    less_than:      { text: '小于等于',     input: 1, value:'<='},
    less:           { text: '小于',         input: 1, value:'<'},
    between:        { text: '介于',         input: 2, value:'>=<='},
    eq0:            { text: '等于0',        input: 0, value:'=0'} ,
    neq0:           { text: '不等于0',      input: 0, value:'!=0'},
};
// 配置选项
export const FILTER_NUMBER_DATA_OPTIONS = Object.keys(FILTER_NUMBER_DATA).map(key=> {
    return {
        label:  FILTER_NUMBER_DATA[key].text,
        value: key,
        input: FILTER_NUMBER_DATA[key].input
    }
});
// 需要作为排序条件的 参数
export const DIMENSION_FIELD_LIST = [
    { name: 'date', display_name: '数据日期' }
];
export const DIMENSION_FIELD_DATA = DIMENSION_FIELD_LIST.reduce((pre, item)=> {
    pre[item.name] = item;
    return pre;
}, {});
// 预览操作信息

//需要预览的字段
export const DIMENSION_PREVIEW_LIST = [ 'm_material_url', 'wk_material_url', ];
// 不能下载素材的 维度
export const DIMENSION_PREVIEW_NODOWN_LIST = [ 'wk_material_url', ];

// 展示数量
export const NUM_TYPE = {
    All: '1',
    CUSTOM: '2'
};
// 勾选默认排序数量
export const DEFAULT_DIMENSION_SORT_NUM = 10;

// 素材类型
export const MATERIAL_TYPE = {
    image: '图片',
    video: '视频'
}